<app-loader *ngIf="loading"></app-loader>
<div class="public-page card-page">
    <div class="public-container public-container_transparent">
        <form [formGroup]="form">
            <div class="public-page-h1 public-page-h1_text-align_center">
                Введите номер и срок действия карты &laquo;Мир&raquo;
            </div>

            <div class="card-info-form">
                <div class="row p-grid">
                    <!-- Номер карты -->
                    <div class="col p-col p-col-12 p-sm-8 p-md-8 p-lg-6 p-lg-offset-2">
                        <div class="p-float-label card-info-form__card-number">
                            <input type="text"
                                   id="pan"
                                   pInputText
                                   formControlName="pan"
                                   mask="0000 0000 0000 0*"
                                   maxlength="22"
                                   autocomplete="off"
                            >
                            <label for="pan">Номер карты</label>
                        </div>
                    </div>
                    <!-- Месяц истечения -->
                    <div class="col p-col p-col-6 p-sm-2 p-md-2 p-lg-1">
                        <div class="p-float-label">
                            <input type="text"
                                   id="month"
                                   pInputText
                                   formControlName="month"
                                   mask="00"
                                   maxlength="2"
                                   autocomplete="off"
                            >
                            <label for="month">ММ</label>
                        </div>
                    </div>
                    <!-- Год истечения -->
                    <div class="col p-col p-col-6 p-sm-2 p-md-2 p-lg-1">
                        <div class="p-float-label">
                            <input type="text"
                                   id="year"
                                   pInputText
                                   formControlName="year"
                                   mask="00"
                                   maxlength="2"
                                   autocomplete="off"
                            >
                            <label for="year">ГГ</label>
                        </div>
                    </div>

                    <div class="col p-col p-col-12 p-lg-offset-2">
                        <div class="ui-errors-quotes"
                             *ngIf="
                                (form.get('pan').touched && form.get('pan').invalid) ||
                                (form.get('month').touched && form.get('month').invalid) ||
                                (form.get('year').touched && form.get('year').invalid)"
                        >
                            <small>{{actualErrorMessages.pan || actualErrorMessages.month || actualErrorMessages.year}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="for-btn for-btn_text-align_center">
                <button pButton
                        label="Продолжить"
                        class="for-btn__button"
                        type="submit"
                        [disabled]="form.invalid"
                        (click)="submitForm()"
                ></button>
            </div>
        </form>
    </div>
</div>
